<template>
  <div class="gas">
    <!-- 最上面部分 -->
    <div class="gas-right--head">
      <router-link to="/gasManage" class>加油站</router-link>&nbsp;/&nbsp;
      <span>增加站点</span>
    </div>
    <div class="gas-right--content">
      <el-form ref="form" :model="form" label-width="auto">
        <el-form-item label="店铺logo">
          <div class="o-flex o-alignEnd">
            <el-upload
              class="avatar-uploader"
              :action="upImgBaseUrl"
              :show-file-list="false"
              :http-request="uploadImg"
            >
              <img
                v-if="form.imageUrl"
                id="img"
                :src="form.imageUrl"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>

        <el-form-item label="店铺二维码" v-if="id">
          <div class="o-flex o-alignEnd">
            <div ref="qrCodeUrl"></div>
            <el-link type="primary" class="o-m-l-10" @click="onDowImg"
              >下载</el-link
            >
          </div>
        </el-form-item>

        <el-form-item label="店铺名称">
          <el-input
            v-model="form.storeName"
            placeholder="请输入名称"
            style="width:304px;"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>

        <el-form-item label="店铺公告">
          <el-input
            v-model="form.shopStoreNotice"
            placeholder="请输入内容"
            style="width:474px;"
            maxlength="150"
            show-word-limit
          ></el-input>
        </el-form-item>

        <el-form-item label="联系电话">
          <el-input
            v-model="form.contactNumber"
            placeholder="请输入联系方式"
            style="width:205px;"
            maxlength="13"
            type="number"
          ></el-input>
        </el-form-item>

        <el-form-item label="营业时间">
          <el-time-select
            v-model="form.startTime"
            :picker-options="{
              start: '00:00',
              step: '00:30',
              end: '24:00'
            }"
            placeholder="请选择开始时间"
          ></el-time-select>
          <el-time-select
            v-model="form.endTime"
            :picker-options="{
              start: '00:00',
              step: '00:30',
              end: '24:00'
            }"
            placeholder="请选择结束时间"
          ></el-time-select>
          <div class="o-font-12" style="color:#F78989;">
            提示：不在营业时间内，将无法接单，即使店铺状态为正常运营
          </div>
        </el-form-item>

        <el-form-item label="门店所在地">
          <el-cascader
            ref="cascader"
            v-model="form.storeAddressVal"
            :options="form.options"
            @change="cityNameCascaderHandler"
            :props="{ expandTrigger: 'click' }"
            style="width:264px;"
          ></el-cascader>
        </el-form-item>

        <el-form-item label="详细地址">
          <el-input
            v-model="form.storeAddress"
            placeholder="请点击右侧去定位选择详细地址"
            :disabled="true"
            style="width:474px;"
          >
            <el-button slot="append" @click="showDialogMap">去定位</el-button>
            <!-- <template slot="append" @click="showDialogMap">去定位</template> -->
          </el-input>
        </el-form-item>

        <el-form-item label="店铺状态">
          <el-switch v-model="form.isBusiness"></el-switch>
        </el-form-item>

        <el-form-item label>
          <el-button type="primary" round @click="onSubmit">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 地图定位 -->
    <el-dialog
      width="510px"
      :visible.sync="dialogMapVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
      <div slot="title">地图定位</div>
      <baidu-map
        v-if="dialogMapVisible"
        class="map"
        :center="center"
        :zoom="zoom"
        @ready="mapReadyHandler"
        @click="getPoint"
        :scroll-wheel-zoom="true"
      >
        <bm-control :offset="{ width: '10px', height: '10px' }">
          <el-input v-model="keyword" placeholder="请输入地名关键字"></el-input>
        </bm-control>
        <bm-local-search
          :keyword="keyword"
          :auto-viewport="true"
          :location="location"
          zoom="12.8"
          style="display: none;"
        ></bm-local-search>
        <bm-marker :position="postionMap">
          <bm-info-window
            :show="show"
            @close="infoWindowClose"
            @open="infoWindowOpen"
            style="font-size: 14px;"
          >
            <p>站点：{{ add.siteName }}</p>
            <p>站点地址：{{ add.site }}</p>
          </bm-info-window>
        </bm-marker>
      </baidu-map>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveStationAddress">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  addOrUpdateGasStation,
  uploadImg,
  gasStationInfo
} from "@/components/api/index.js";
import request from "@/assets/request.js";
import cityData2 from "../../assets/cityData2.json";
import html2canvas from "html2canvas";
import QRCode from "qrcodejs2";
import { gg2bd, bd2gg } from "@/utils/map.js";
export default {
  data() {
    return {
      id: this.$route.query.id, //加油站ID 存在时说明是编辑,不存在就是添加
      upImgBaseUrl: request.upImgBaseUrl,
      form: {
        imageUrl: "",
        options: cityData2,
        storeName: "", //店铺名称
        shopStoreNotice: "", //公告
        contactNumber: "", //联系电话
        storeAddressVal: "", //门店地址索引
        storeAddress: "", //门店地址
        cityId: "", //城市
        districtId: "", //区域
        provinceId: "", //省份
        isBusiness: true, //是否营业 1是 2不是
        lng: "",
        lat: "",
        startTime: "",
        endTime: ""
      },
      location: "",
      keyword: "",
      add: {
        siteName: "",
        site: "",
        jd: "",
        wd: "",
        desce: "",
        type: "",
        jgName: "",
        jgNum: ""
      },
      dialogMapVisible: false,
      postionMap: {
        //地图坐标
        lng: 120.211486,
        lat: 30.256576
      },
      center: { lng: 120.211486, lat: 30.256576 },
      zoom: 12.8,
      show: false,
      mapCenter: ""
    };
  },
  mounted() {},
  created() {
    this.gasStationInfo();
  },
  methods: {
    gasStationInfo() {
      //获取单个加油站详情
      console.log(this.id);
      if (this.id) {
        //判断id是否存在
        gasStationInfo({ shopStoreId: this.id }).then(res => {
          if (res.code == 1) {
            let data = res.data;
            let { lng, lat } = gg2bd(data.longitude, data.latitude);
            this.form.storeName = data.storeName;
            this.form.storeAddress = data.storeAddress;
            this.form.shopStoreNotice = data.shopStoreNotice;
            this.form.imageUrl = data.shopStoreImage;
            this.form.storeAddressVal = [
              data.provinceId + "",
              data.cityId + "",
              data.districtId + ""
            ];
            this.form.contactNumber = data.contactNumber;
            this.form.isMaster = data.isMaster;
            this.form.mainStore = data.isMaster == 1 ? data.storeAddress : "";
            this.form.startTime = data.businessHours.substring(0, 5);
            this.form.endTime = data.businessHours.substring(
              data.businessHours.lastIndexOf("-") + 1,
              data.businessHours.length
            );
            this.form.lng = lng;
            this.form.lat = lat;
            this.form.isBusiness = data.isBusiness == 1 ? true : false;
            this.mapCenter = data.storeAddress;
            new QRCode(this.$refs.qrCodeUrl, {
              text: `https://ydc.yichengshi.cn/gas/#/gasStationInfo?shopId=${data.shopId}&shopStoreId=${data.shopStoreId}`, // 需要转换为二维码的内容
              width: 200,
              height: 200,
              colorDark: "#000000",
              colorLight: "#ffffff",
              correctLevel: QRCode.CorrectLevel.H
            });
          }
          console.log(res);
        });
      }
    },
    getCheckedNodes(a) {
      console.log(a, 111);
    },
    cityNameCascaderHandler(value, label) {
      let cascader = this.$refs["cascader"].getCheckedNodes()[0].pathLabels;
      this.mapCenter = `${cascader[0]}${cascader[1]}${cascader[2]}`;
      console.log(this.mapCenter);
    },
    showDialogMap() {
      if (!this.form.storeAddressVal) {
        this.$notify({
          title: "警告",
          message: "请先选择城市",
          type: "warning",
          duration: 6000
        });
        return;
      }
      this.dialogMapVisible = true;
    },
    infoWindowClose() {
      this.show = false;
    },
    infoWindowOpen() {
      setInterval(() => {
        this.show = true;
      }, 100);
    },
    mapReadyHandler({ BMap, map }) {
      this.center = this.mapCenter;
      if (this.id) {
        this.postionMap.lat = this.form.lat;
        this.postionMap.lng = this.form.lng;
      }
      console.log(this.center);
      this.zoom = 12.8;
    },
    getPoint(e) {
      //点击地图获取一些信息，
      this.show = true;
      this.postionMap.lng = e.point.lng; //通过  e.point.lng获取经度
      this.postionMap.lat = e.point.lat; //通过  e.point.lat获取纬度
      this.add.jd = e.point.lng;
      this.add.wd = e.point.lat;
      this.zoom = e.target.getZoom();

      let geocoder = new BMap.Geocoder(); //创建地址解析器的实例
      geocoder.getLocation(e.point, rs => {
        console.log(rs);
        this.add.site = rs.address;
        this.add.lng = rs.point.lng;
        this.add.lat = rs.point.lat;
        this.form.storeAddress = rs.address;
        console.log(rs.point.lng, rs.point.lat);
        let { lng, lat } = bd2gg(rs.point.lng, rs.point.lat);
        this.form.lng = lng;
        this.form.lat = lat;
      });
    },
    saveStationAddress() {
      this.dialogMapVisible = false;
    },
    uploadImg(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      uploadImg(imgUploadForm)
        .then(res => {
          console.log(res);
          if (res.data.code == 1) {
            this.form.imageUrl = res.data.data.url;
          }
        })
        .catch(err => {
          this.$notify({
            title: "警告",
            message: "图片上传失败",
            type: "warning",
            duration: 6000
          });
        });
    },
    onDowImg() {
      html2canvas(this.$refs.qrCodeUrl, {
        useCORS: true,
        width: img.width,
        height: img.height
      }).then(canvas => {
        let dataURL = canvas.toDataURL("image/jpeg", 1.0);
        console.log(dataURL);
        var a = document.createElement("a"); // 创建一个a节点插入的document
        var event = new MouseEvent("click"); // 模拟鼠标click点击事件
        a.download = "二维码"; // 设置a节点的download属性值
        a.href = dataURL; // 将图片的src赋值给a节点的href
        a.dispatchEvent(event);
      });
      let dataURL = canvas.toDataURL("image/jpeg", 1.0);
    },
    onSubmit() {
      var startTime = this.form.startTime.split(":");
      var endTime = this.form.endTime.split(":");
      var sj1 = parseInt(endTime[0]) * 12 + endTime[1];
      var sj2 = parseInt(startTime[0]) + parseInt(startTime[1]);
      if (sj1 < sj2) {
        this.$message.warning("开始时间大于结束时间");
        return false;
      }
      let info = this.form;
      if (!info.imageUrl) {
        this.$notify({
          title: "警告",
          message: "请上传到店铺logo",
          type: "warning",
          duration: 6000
        });
        return;
      }
      if (!info.storeName) {
        this.$notify({
          title: "警告",
          message: "请输入名称",
          type: "warning",
          duration: 6000
        });
        return;
      }

      if (!info.shopStoreNotice) {
        this.$notify({
          title: "警告",
          message: "请输入门店公告",
          type: "warning",
          duration: 6000
        });
        return;
      }
      if (!info.contactNumber) {
        this.$notify({
          title: "警告",
          message: "请输入手机号码",
          type: "warning",
          duration: 6000
        });
        return;
      }
      if (!info.startTime || !info.endTime) {
        this.$notify({
          title: "警告",
          message: "请输入营业时间",
          type: "warning",
          duration: 6000
        });
        return;
      }
      if (!this.mapCenter) {
        this.$notify({
          title: "警告",
          message: "请选择门店地址",
          type: "warning",
          duration: 6000
        });
        return;
      }
      if (!info.storeAddress) {
        this.$notify({
          title: "警告",
          message: "请选择详细地址",
          type: "warning",
          duration: 6000
        });
        return;
      }

      let form = {
        shopStoreId: this.id,
        storeName: info.storeName,
        shopStoreImage: info.imageUrl,
        businessHours: `${info.startTime}-${info.endTime}`,
        isBusiness: info.isBusiness ? 1 : "",
        contactNumber: info.contactNumber,
        shopStoreNotice: info.shopStoreNotice,
        storeAddress:
          info.isMaster == 1 && info.isMaster
            ? info.mainStore
            : info.storeAddress,
        longitude: info.lng,
        latitude: info.lat,
        cityId: info.storeAddressVal[0],
        provinceId: info.storeAddressVal[1],
        districtId: info.storeAddressVal[2]
      };

      console.log(form);

      addOrUpdateGasStation(form)
        .then(res => {
          if (res.code == 1) {
            this.$notify({
              title: "成功",
              message: "添加成功",
              type: "success",
              duration: 6000
            });
            this.$router.go(-1);
          } else {
            this.$notify({
              title: "警告",
              message: res.msg,
              type: "error",
              duration: 6000
            });
          }
          console.log(res);
        })
        .catch(err => {
          this.$notify({
            title: "警告",
            message: "保存失败请联系客服",
            type: "error",
            duration: 6000
          });
        });
    }
  }
};
</script>
<style lang="">
.avatar-uploader .el-upload {
  width: 140px;
  height: 140px;
}
</style>
<style lang="scss" scoped>
.gas {
  width: calc(100vw - 200px);
  height: calc(100vh);
  margin-left: 200px;
  min-width: 1340px;
  background-color: #f8f8f8;
  padding-top: 87px;
  box-sizing: border-box;
  padding-right: 25px;
}
.gas-right--head {
  height: 66px;
  line-height: 66px;
  background-color: #fff;
  padding-left: 31px;
  font-weight: 400;
  display: inline-flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  font-size: 14px;
  z-index: 9;
  a {
    color: #333333;
  }
  span {
    color: #5f6165;
  }
}
.gas-right--content {
  padding: 22px 30px 40px 26px;
  // padding: 87px 25px 0 28px;
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.avatar {
  width: 140px;
  height: 140px;
  object-fit: cover;
  display: block;
}
.map {
  width: 100%;
  height: 400px;
  　　::v-deep .anchorBL {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/gasAddInt.vue